import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sphere-volume-calculator',
  component: () => import('../../routes/SphereVolumeCalculator.svelte'),
  card: {
    id: 'sphere-volume-calculator',
    title: 'Sphere Volume Calculator',
    description: 'Calculate the volume, surface area, and diameter of a sphere from its radius.',
    icon: 'sphere',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/sphere-volume-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Sphere Volume Calculator – Volume, Surface Area & Diameter',
    description:
      'Free sphere volume calculator to find volume, surface area, and diameter from radius. Includes formulas, step-by-step results, and unit conversions.',
  },
};

export default meta;